// @ts-nocheck
// @ts-nocheck
import { useState } from 'react'
import { useQuery, useMutation } from 'react-query'
import { 
  Users as UsersIcon, 
  Plus, 
  Search, 
  Edit2, 
  Trash2, 
  Shield,
  User,
  CheckCircle,
  XCircle
} from 'lucide-react'
import { apiService } from '../services/api'

const Users = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [showCreate, setShowCreate] = useState(false)
  const [editingUser, setEditingUser] = useState<any>(null)
  const [form, setForm] = useState({
    username: '',
    email: '',
    full_name: '',
    password: '',
    role: 'viewer',
    phone: '',
    company_name: '',
    banking_name: '',
    billing_address: '',
    billing_email: '',
    billing_phone: '',
    tax_id: '',
    notes: '',
    is_active: true,
  })
  
  const { data: users, isLoading, refetch } = useQuery('users',
    () => apiService.getUsers()
  )

  const createUser = useMutation(
    () => apiService.createUser(form),
    {
      onSuccess: () => {
        setShowCreate(false)
        resetForm()
        refetch()
      },
      onError: (error: any) => {
        alert(error?.response?.data?.message || 'Failed to create user')
      }
    }
  )

  const updateUser = useMutation(
    () => apiService.updateUser(editingUser.id, form),
    {
      onSuccess: () => {
        setEditingUser(null)
        resetForm()
        refetch()
      },
      onError: (error: any) => alert(error?.response?.data?.message || 'Failed to update user')
    }
  )

  const deleteUser = useMutation(
    (id: number) => apiService.deleteUser(id),
    {
      onSuccess: () => refetch(),
      onError: (error: any) => alert(error?.response?.data?.message || 'Failed to deactivate user')
    }
  )

  const resetForm = () => setForm({
    username: '',
    email: '',
    full_name: '',
    password: '',
    role: 'viewer',
    phone: '',
    company_name: '',
    banking_name: '',
    billing_address: '',
    billing_email: '',
    billing_phone: '',
    tax_id: '',
    notes: '',
    is_active: true,
  })

  const startEdit = (user: any) => {
    setShowCreate(false)
    setEditingUser(user)
    setForm({
      username: user.username || '',
      email: user.email || '',
      full_name: user.full_name || '',
      password: '',
      role: user.role || 'viewer',
      phone: user.phone || '',
      company_name: user.company_name || '',
      banking_name: user.banking_name || '',
      billing_address: user.billing_address || '',
      billing_email: user.billing_email || '',
      billing_phone: user.billing_phone || '',
      tax_id: user.tax_id || '',
      notes: user.notes || '',
      is_active: !!user.is_active,
    })
  }

  const filteredUsers = users?.data?.filter((user: any) =>
    user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.full_name?.toLowerCase().includes(searchQuery.toLowerCase())
  ) || []

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">User Management</h2>
          <p className="text-slate-500">Manage system users and permissions</p>
        </div>
        <button
          onClick={() => setShowCreate(!showCreate)}
          className="flex items-center space-x-2 px-4 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors"
        >
          <Plus className="h-4 w-4" />
          <span>Add User</span>
        </button>
      </div>

      {(showCreate || editingUser) && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">{editingUser ? 'Edit User Profile' : 'Create User'}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <input className="px-3 py-2 border rounded-lg disabled:bg-slate-100" placeholder="Username" disabled={!!editingUser} value={form.username} onChange={e => setForm({...form, username: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Full name" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder={editingUser ? 'New password' : 'Password'} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
            <select className="px-3 py-2 border rounded-lg" value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
              <option value="viewer">Read Only</option>
              <option value="admin">Admin</option>
              <option value="superadmin">Superadmin</option>
            </select>
            <select className="px-3 py-2 border rounded-lg" value={String(form.is_active)} onChange={e => setForm({...form, is_active: e.target.value === 'true'})}>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
            <input className="px-3 py-2 border rounded-lg" placeholder="Phone number" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Company information" value={form.company_name} onChange={e => setForm({...form, company_name: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Banking name" value={form.banking_name} onChange={e => setForm({...form, banking_name: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Billing email" value={form.billing_email} onChange={e => setForm({...form, billing_email: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Billing phone" value={form.billing_phone} onChange={e => setForm({...form, billing_phone: e.target.value})} />
            <input className="px-3 py-2 border rounded-lg" placeholder="Tax/GST ID" value={form.tax_id} onChange={e => setForm({...form, tax_id: e.target.value})} />
            <textarea className="px-3 py-2 border rounded-lg md:col-span-2" placeholder="Billing address" rows={3} value={form.billing_address} onChange={e => setForm({...form, billing_address: e.target.value})} />
            <textarea className="px-3 py-2 border rounded-lg md:col-span-2" placeholder="Account notes" rows={3} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} />
          </div>
          <div className="mt-4 flex justify-end space-x-3">
            <button onClick={() => { setShowCreate(false); setEditingUser(null); resetForm() }} className="px-4 py-2 border rounded-lg">Cancel</button>
            <button onClick={() => editingUser ? updateUser.mutate() : createUser.mutate()} disabled={createUser.isLoading || updateUser.isLoading} className="px-4 py-2 bg-sky-600 text-white rounded-lg disabled:opacity-60">
              {editingUser ? 'Save Changes' : 'Create User'}
            </button>
          </div>
        </div>
      )}

      {/* Search */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
        <input
          type="text"
          placeholder="Search users..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
        />
      </div>

      {/* Users Table */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <table className="min-w-full divide-y divide-slate-200">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">User</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Role</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase">Last Login</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200">
            {isLoading ? (
              <tr>
                <td colSpan={5} className="px-6 py-12 text-center">
                  <div className="spinner h-8 w-8 border-4 border-sky-600 border-t-transparent rounded-full mx-auto" />
                </td>
              </tr>
            ) : filteredUsers.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-6 py-12 text-center text-slate-500">
                  <UsersIcon className="h-12 w-12 mx-auto mb-4 text-slate-300" />
                  <p>No users found</p>
                </td>
              </tr>
            ) : (
              filteredUsers.map((user: any) => (
                <tr key={user.id} className="hover:bg-slate-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-sky-100 flex items-center justify-center">
                        <User className="h-5 w-5 text-sky-600" />
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-slate-900">
                          {user.full_name || user.username}
                        </div>
                        <div className="text-sm text-slate-500">{user.email}</div>
                        <div className="text-xs text-slate-400">{user.company_name || user.phone || 'No profile details'}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      user.role === 'superadmin'
                        ? 'bg-red-100 text-red-800'
                        : user.role === 'admin'
                          ? 'bg-purple-100 text-purple-800'
                          : 'bg-slate-100 text-slate-800'
                    }`}>
                      <Shield className="h-3 w-3 mr-1" />
                      {user.role === 'viewer' ? 'read only' : user.role}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      user.is_active 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {user.is_active ? (
                        <><CheckCircle className="h-3 w-3 mr-1" /> Active</>
                      ) : (
                        <><XCircle className="h-3 w-3 mr-1" /> Inactive</>
                      )}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-500">
                    {user.last_login || 'Never'}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex items-center justify-end space-x-2">
                      <button onClick={() => startEdit(user)} className="p-2 text-slate-400 hover:text-sky-600 hover:bg-sky-50 rounded-lg transition-colors">
                        <Edit2 className="h-4 w-4" />
                      </button>
                      <button onClick={() => confirm('Deactivate this user?') && deleteUser.mutate(user.id)} className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Users
